function Loading() {
	return (
		<div className="loader">
			<h1>LOADING ...</h1>
		</div>
	);
}

export default Loading;
